/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */

/// Componente encargado de filtrar los resultados de los paquetes deportivos ///

import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import useFilterPackages from "../../hooks/useFilterPackages";

import Translate from "../../i18n/Translate";
import returnDateText from "../../helpers/ReturnDateText";

const Filters = ({ setPackagesFiltered, loading, data }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search); // Nos trae los parámetros de la url, query.get()

  const [eventsOptions, setEventsOptions] = useState([
    { value: "", label: "Ninguno" },
  ]);
  const [locationOptions, setLocationOptions] = useState([
    { value: "", label: "Ninguno" },
  ]);
  const [monthsOptions, setMonthsOptions] = useState([
    { value: "", label: "Ninguno" },
  ]);
  const [yearsOptions, setYearsOptions] = useState([
    { value: "", label: "Ninguno" },
  ]);

  const [eventsSelected, setEventsSelected] = useState(
    query.get("event") || ""
  );
  const [locationSelected, setLocationSelected] = useState(
    query.get("country") || ""
  );
  const [monthsSelected, setMonthsSelected] = useState("");
  const [yearsSelected, setYearsSelected] = useState("");

  const { t } = useTranslation();
  const { filteredPackets, setAppliedFilters } = useFilterPackages(data);

  const handleSubmit = (e) => {
    e.preventDefault();

    setAppliedFilters({
      event: eventsSelected,
      location: locationSelected,
      month: monthsSelected,
      year: yearsSelected,
    });
  };

  const handleReset = (e) => {
    e.preventDefault();

    setEventsSelected("");
    setLocationSelected("");
    setMonthsSelected("");
    setYearsSelected("");

    setAppliedFilters({
      events: "",
      location: "",
      month: "",
      year: "",
    });
  };

  const handleSelect = (e, type) => {
    const { value } = e;

    type === "events"
      ? setEventsSelected(value)
      : type === "locations"
      ? setLocationSelected(value)
      : type === "months"
      ? setMonthsSelected(value)
      : type === "years"
      ? setYearsSelected(value)
      : null;
  };

  const setValuesFilters = (data) => {
    if (data?.length) {
      const newEvents = [];
      const newLocation = [];
      const newMonth = [];
      const newYear = [];

      data.forEach((item) => {
        const event = item.category;
        const location = item.location;
        const date = item.date;

        if (!newEvents.find((option) => option.value === event)) {
          newEvents.push({ value: event, label: event });
          setEventsOptions([...eventsOptions, ...newEvents]);
        }

        if (!newLocation.find((option) => option.value === location)) {
          newLocation.push({
            value: location,
            label: location.replace("-", " "),
          });
          setLocationOptions([...locationOptions, ...newLocation]);
        }

        if (
          !newMonth.find(
            (option) => option.value === returnDateText(date).month
          )
        ) {
          newMonth.push({
            value: returnDateText(date).month,
            label: returnDateText(date).monthName,
          });

          newMonth.sort((a, b) => {
            if (a.value < b.value) return -1;
            if (a.value > b.value) return 1;
            return 0;
          });

          setMonthsOptions([...monthsOptions, ...newMonth]);
        }

        if (
          !newYear.find((option) => option.value === returnDateText(date).year)
        ) {
          newYear.push({
            value: returnDateText(date).year,
            label: returnDateText(date).year,
          });

          newYear.sort((a, b) => {
            if (a.value < b.value) return -1;
            if (a.value > b.value) return 1;
            return 0;
          });

          setYearsOptions([...yearsOptions, ...newYear]);
        }
      });
    }
  };

  useEffect(() => {
    setPackagesFiltered(filteredPackets);
  }, [filteredPackets]);

  useEffect(() => {
    setValuesFilters(data);
  }, [data]);

  return (
    <>
      <form
        className="sport__filters"
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <h4>
          <Translate langkey="psports.filters.title1" />
        </h4>

        <div className="sport__filters__selects">
          <Select
            isLoading={loading}
            isSearchable={false}
            hideSelectedOptions
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder={t("psports.filters.option1")}
            onChange={(value) => setEventsSelected(value.value)}
            defaultValue={{
              value: query.get("event") || eventsOptions[0].value,
              label: query.get("event") || eventsOptions[0].label,
            }}
            options={eventsOptions}
          />
        </div>

        <br />

        {/* Fecha */}
        <p>
          <Translate langkey="psports.filters.title2" />
        </p>

        <div className="sport__filters__selects">
          <Select
            options={monthsOptions}
            isSearchable={false}
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder={t("psports.filters.option2")}
            hideSelectedOptions
            onChange={(e) => handleSelect(e, "months")}
          />
        </div>

        <div className="sport__filters__selects">
          <Select
            options={yearsOptions}
            isSearchable={false}
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder={t("psports.filters.option3")}
            hideSelectedOptions
            onChange={(e) => handleSelect(e, "years")}
          />
        </div>

        {/* Location */}
        <p>
          <Translate langkey="psports.filters.title3" />
        </p>

        <div className="sport__filters__selects">
          <Select
            options={locationOptions}
            isSearchable={false}
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder={t("psports.filters.option5")}
            hideSelectedOptions
            onChange={(e) => handleSelect(e, "locations")}
            defaultValue={{
              value: query.get("country") || locationOptions[0].value,
              label: query.get("country") || locationOptions[0].label,
            }}
          />
        </div>

        {/* Botones */}
        <div className="sport__filters__buttons">
          <button type="reset">
            <Translate langkey="psports.filters.reset" />
          </button>
          <button type="submit">
            <Translate langkey="psports.filters.apply" />
          </button>
        </div>
      </form>
    </>
  );
};

export default Filters;
